import {StorageUtils} from 'xmgoing-utils';
import {ref} from "vue";
import {getMenus, getSpaceMenus} from "@/router/menus";
import {Menu} from "@/router/types";
// import {executeOpenSubMenuItem} from "@/layouts/layoutFrame/technology/hooks/useSubMenuEditor";
import {getMenuEntryKey, getMenuObjByKey, PointUtils} from "@/utils/buryingPoint";
import systemMenu from "@/layouts/data/systemMenu";
import {RoleEnum} from "@/enums/roleEnum";
import {useAppStore} from "@/store/modules/app";
import {executeSetCrumbName} from "@/layouts/layoutFrame/scaLayout/hooks/useBreadCrumbHook";
import {useMenuStore} from "@/layouts/layoutFrame/military/viewStore/menuStore";
import eventBus from '@/events/eventBus';
import { useMultipleTabStore } from '@/store/modules/multipleTab';

export function useMenuHooks(router,t) {
  const curActiveSpaceId = ref('');
  const menuClickFlag=ref(false);
  const tabStore = useMultipleTabStore();

  const homeItem={
    id: 'analysis',
    path: '/dashboard/analysis',
    name: t('首页'),
    source: 'remix-icon ri-home-6-line',
    type: 'page'
  }
  // Menu array
  const menusRef:any = ref<Menu[]>([

  ]);


  const  afterClickMenuByTarget=function ({targetObj,key}){
    const target = targetObj.target;
    const navPath = (target?.paramPath || target?.path || key) as string;
    if(target.name){
      document.title =target.name;
      StorageUtils.addItem("curMenuName",target.name);
    }
    StorageUtils.addItem("curMenuId",target.appOldId||target.id);
    //存储当前menu的id 和 名称
    StorageUtils.addSessionItem("curMenuId",target.appOldId||target.id);
    // 侧栏消歧：唯一菜单入口 id（同 path 多入口不能靠 path）
    StorageUtils.addSessionItem("curMenuEntryId", target.id);
    StorageUtils.addSessionItem("curMenuName",target.name);
    if (navPath && target.name) {
      StorageUtils.addSessionItem(navPath, target.name);
    }
    if (target.path) {
      tabStore.bindTabMenuEntryId(target.path, target.id);
    }
    eventBus.emit('menuEntryChange', {
      entryId: target.id,
      path: target.path,
    });
    if (unref(targetObj).target.openType === 'window'||unref(targetObj).target.openType === "openNewWin") {
      let Url = new URL(navPath, location.origin);
      const sessionId = StorageUtils.getSessionItem("sessionId")!;
      if (!import.meta.env.PROD) {
        if (navPath.startsWith('/big-screen')) {
          Url.port = import.meta.env.VITE_APP_BIG_SCREEN;
          Url.searchParams.set("sessionId", sessionId);
        }
      }
      window.open(Url.toString());
      return
    }
    executeSetCrumbName(target);
    const appStore = useAppStore();
    appStore.setPageName(target.name);
    appStore.clearActiveSubMenu();
  }
  const menuStore = useMenuStore();
  const {
    menuProps
  }:any = storeToRefs(menuStore)
  /**
   * 菜单点击事件
   * @param key 菜单入口 id，或回退用的 path（收藏/常用等未带 id 时）
   * @param menuId 可选；若传入则优先按入口 id 消歧
   */
  const menuClick = function ({key, menuId}: {key: string; menuId?: string | number},menuUserList?:any) {
    unref(menuProps).showMenu=false;
    menuClickFlag.value=true;
    setTimeout(()=>{
      menuClickFlag.value=false;
    },500)
    const targetObj: any = {};
    const lookupKey = menuId != null && menuId !== '' ? String(menuId) : key;
    //菜单埋点
    PointUtils.addMenuPoint({key: lookupKey,menuList:menuUserList||unref(menusRef)});
    if(menuUserList){
      getMenuObjByKey(menuUserList, lookupKey, targetObj);
    }else{
      getMenuObjByKey(unref(menusRef), lookupKey, targetObj);
    }
    if (targetObj.target) {
      afterClickMenuByTarget({targetObj,key: lookupKey});
    }
    // 导航必须用真实 path；叶子 key 已是入口 id 时不能直接 push(key)
    let navPath = (targetObj.target?.paramPath || targetObj.target?.path || '') as string;
    if (!navPath && (key + '').indexOf('/') >= 0) {
      navPath = key;
    }
    if ((navPath + "").indexOf("/") >= 0) {
      if(!(navPath.indexOf("?")>0)){
        navPath=navPath+'?loginUserType=user'
      }else{
        navPath=navPath+'&loginUserType=user'
      }
      const showApp = StorageUtils.getSessionItem("showApp");
      const templateId = StorageUtils.getSessionItem("templateId");
      if (showApp + '' === "true") {
        navPath = navPath + "?templateId=" + templateId;
      }
      //如果是http开头的 则用window.open的方式进行打开
      if ((navPath + "").indexOf("http:") >= 0 || (navPath + "").indexOf("https:") >= 0) {
        navPath = navPath + "&sessionId=" + StorageUtils.getSessionItem("sessionId");
        window.open(navPath);
      } else if ((navPath + "").startsWith('/jieSeriesDashboard')) {
        window.open(new URL(navPath, location.origin).toString(), '_blank');
      } else {
        router.push({path: navPath});
      }
    } else {
      return 0;
    }
  }

  /**
   * 按当前路由同步侧栏选中（叶子为菜单入口 id）
   */
  const syncSelectedKeysFromRoute = function (selectedKeys, openKeys?, routePath?: string) {
    const curUrl = routePath || router.currentRoute.value?.path;
    if (!curUrl) return;
    const targetObj: any = {};
    getMenuObjByKey(unref(menusRef), curUrl, targetObj);
    if (targetObj?.target) {
      if (openKeys && targetObj.target.parentId) {
        unref(openKeys).push(targetObj.target.parentId);
      }
      afterClickMenuByTarget({targetObj, key: curUrl});
      selectedKeys.value = [getMenuEntryKey(targetObj.target)];
    }
  }

  /**
   * 点击父菜单项
   * @param key
   */
  const pMenuItemClick = function ({key}) {
    const pItem = unref(menusRef).filter((item: any) => {
      return item.path === key;
    })[0];
    if (pItem) {
      executeOpenSubMenuItem({item: pItem});
    }
  }

  // get menus
  async function genMenus({hasHomeMenu = true,hasLineMenu=false}) {
    const position=StorageUtils.getSessionItem("loginUserType");
    //如果是系统管理员
    if(position===RoleEnum.USER_SYSTEM_ROLE){
      menusRef.value =systemMenu;
    }
    menusRef.value = [];
    // normal mode
    const menus = await getMenus();
    const menusAll: any = [];
    if (hasHomeMenu) {
      menusAll.push(homeItem)
      menusAll.push({type:'line'})
    }
    menus.forEach((itemDb,index) => {
      if (itemDb && itemDb.children) {
        if(hasLineMenu&&index!==0){
          (itemDb as any).type = "line";
          menusAll.push(itemDb);
        }
        menusAll.push(...itemDb.children);
      } else {
        menusAll.push(itemDb);
      }
    })
    menusRef.value = menusAll;
  }

  /**
   * 获取易用菜单
   * @param hasHomeMenu
   */
  async function genAppMenus(hasHomeMenu = true,backFun) {
    const position=StorageUtils.getSessionItem("loginUserType");
    if(position===RoleEnum.USER_SYSTEM_ROLE){
      menusRef.value =systemMenu;
    }
    menusRef.value = [];
    // normal mode
    const menus = await getMenus();
    const menusAll: any = [];
    if (hasHomeMenu) {
      menusAll.push(homeItem)
    }
    menus.forEach((itemDb) => {
      if (itemDb && itemDb.children && itemDb.children.length > 0) {
        menusAll.push(itemDb);
      }
    })
    backFun&&backFun(menusAll);
    menusRef.value = menusAll;
  }

  /**
   * 数据加载后的方法
   * @param menus
   * @param hasHomeMenu
   */
  const afterLoadMenus = function (menus, hasHomeMenu) {
    const menusAll: any = [];
    if (hasHomeMenu) {
      menusAll.push(homeItem)
    }
    menus.forEach((itemDb) => {
      if (itemDb && itemDb.children) {
        (itemDb as any).type = "line";
        menusAll.push(itemDb);
        menusAll.push(...itemDb.children);
      } else {
        menusAll.push(itemDb);
      }
    })
    menusRef.value = menusAll;
  }

  /**
   * 获取易用菜单
   * @param hasHomeMenu
   */
  async function genSpaceMenus(hasHomeMenu: boolean, spaceId: string) {
    curActiveSpaceId.value = spaceId;
    // normal mode
    const menus = await getSpaceMenus(spaceId);
    if(menus&&menus[0]&&menus[0].children){
      afterLoadMenus(menus[0].children, hasHomeMenu);
    }
  }


  return {
    menuClickFlag,
    afterClickMenuByTarget,
    syncSelectedKeysFromRoute,
    curActiveSpaceId,
    genSpaceMenus,
    genAppMenus,
    pMenuItemClick,
    menusRef,
    genMenus,
    menuClick,
    homeItem,
  };

}
